var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "close 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6917858,19.6917858 L19.6917858,19.6917858 C20.1027381,19.2808336 20.1027381,18.6128732 19.6917858,18.2006164 L11.4910063,9.99983692 L19.6917858,1.79905742 C20.1027381,1.38810522 20.1027381,0.720144812 19.6917858,0.309192609 C19.2808336,-0.103064203 18.6128732,-0.103064203 18.2006164,0.309192609 L9.99983692,8.50997211 L1.79905742,0.309192609 C1.38810522,-0.103064203 0.720144812,-0.103064203 0.309192609,0.309192609 C-0.103064203,0.720144812 -0.103064203,1.38810522 0.309192609,1.79905742 L8.50997211,9.99983692 L0.309192609,18.2006164 C-0.103064203,18.6128732 -0.103064203,19.2808336 0.309192609,19.6917858 C0.720144812,20.1027381 1.38810522,20.1027381 1.79905742,19.6917858 L9.99983692,11.4910063 L18.2006164,19.6917858 C18.6128732,20.1027381 19.2808336,20.1027381 19.6917858,19.6917858",
    id: "Fill-1",
    fill: "#293030"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.811a73cdf116ee24f8269159b2d25dda.svg";
export { ForwardRef as ReactComponent };